import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import EstimateSummary from './EstimateSummary';
import config from '../../helpers/config';
import { sites } from '../../helpers/globalVariables';
import cartEstimate from '../../actions/cartEstimate';
import { getItemsForEstimate } from '../../selectors/getItemsForEstimate';
import { getInvalidItemsCount } from '../../selectors/getInvalidItemsCount';
import { getDiscontinuedItemsCount } from '../../selectors/getDiscontinuedItemsCount';
import localeBase from './EstimateSummary.locale';
import localeThd from './EstimateSummary.locale.11';
import cookiesFactory from '../../../../base/cookies-factory';

import designPricing from '../../services/designPricing/design';

const mapStateToProps = ({ originReducer, estimateBuilder }, ownProps) => {
  const { entities, uiState, designsSummary } = estimateBuilder;
  const { items, containers } = entities;
  const estimate = entities.estimates.byId[ownProps.designId];
  const { isLockedOrOrdered } = estimate;
  const designSummary = designsSummary.designs.find(d => d.designId === ownProps.designId)
  || { hasInStoreMeasureOrder: false };

  const getPromoEndDate = (promoEndDateFromApi) => {
    // promoEndDateFromApi is in UTC.
    // The following will subtract a day if the UTC time is
    // between 5:00 AM - 10:30 AM. (Midnight to 5:30 AM in CST)
    // This is a short term solution and may change in the future.
    const endDate = new Date(promoEndDateFromApi);
    const hour = endDate.getUTCHours();
    const minute = endDate.getUTCMinutes();

    if ((hour === 10 && minute <= 30) || (hour >= 5 && hour < 10)) {
      endDate.setDate(endDate.getDate() - 1);
    }

    return endDate.toLocaleDateString('en-US');
  };

  const locale = config.siteId !== sites.theHomeDepot ? localeBase : localeThd;
  const { mode } = originReducer;
  const isInStore = mode === 'InStore' || false;

  const retail = designPricing(containers.byId, items.byId, 'retail', estimate);
  const subtotal = designPricing(containers.byId, items.byId, 'subtotal', estimate);

  const itemsWithProductCount = getItemsForEstimate(entities, ownProps.designId).reduce(
    (acc, item) => (item.itemProduct ? acc + 1 : acc),
    0,
  );
  const invalidItemCount = getInvalidItemsCount(entities, ownProps.designId);
  const discontinuedItemsCount = getDiscontinuedItemsCount(entities, uiState.selectedEstimate);

  return {
    name: estimate.name,
    subtotal,
    retail,
    promoCode: estimate.promoCode,
    promoEndDate: estimate.promoEndDate ? getPromoEndDate(estimate.promoEndDate) : null,
    containerIds: estimate.containers,
    disableDiyCheckout: invalidItemCount > 0 ||
                        (discontinuedItemsCount > 0 && !cookiesFactory.isInternalUser()) ||
                        itemsWithProductCount === 0 || isLockedOrOrdered ||
                        designSummary.hasInStoreMeasureOrder,
    disableProCheckout: invalidItemCount > 0 || isLockedOrOrdered,
    isLinked: entities.estimates.byId[uiState.selectedEstimate].isLinked,
    locale,
    isInStore,
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({ cartEstimate }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(EstimateSummary);
